<template>
  <button
    class="follow-button"
    :class="{ following: following, loading: loading }"
    @click="toggleFollow"
    :disabled="loading"
  >
    <span :key="following" class="fade-text">
      {{ following ? $t("unfollow") : $t("follow") }}
    </span>
  </button>
</template>

<script>
import { followUser, unfollowUser } from "../../api/axios.js";

export default {
  name: "FollowBtn",
  props: {
    userId: [String, Number],
    isFollowing: Boolean,
  },
  data() {
    return {
      following: this.isFollowing,
      loading: false,
    };
  },
  methods: {
    async toggleFollow() {
      if (this.loading) return;

      this.following = !this.following;
      this.loading = true;

      try {
        if (this.following) {
          await followUser(this.userId);
          this.$emit("follow-change", +1);
        } else {
          await unfollowUser(this.userId);
          this.$emit("follow-change", -1);
        }
      } catch (e) {
        this.following = !this.following;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
.follow-button {
  padding: 8px 10px;
  border-radius: 10px;
  background: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: background 0.2s ease;
  color: #1f1f1f;
}

.follow-button:hover {
  background: rgb(184, 184, 184);
}
</style>
